import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ChangeDetectorRef, inject, OnDestroy} from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { of, Subject } from 'rxjs';
import { catchError, take, takeUntil } from 'rxjs/operators';
import { MsgConfig } from 'src/app/app.messages';
import { AlertService, CommonService, DrugService, ErxService, NotesLogService, PatPreDrugModalService, RxTransferService, UserService } from 'src/app/services';
import { CommonUtil } from 'src/app/utils';
import { PatientInfoUtil } from 'src/app/utils/patient-info.util';
import {  Notes, PharmacyAddress,  RxTranferNode,  RxTransferConfirm } from 'src/app/models/transfer-rx.models';
import { NotesMainCat } from 'src/app/models/notes.enum';
import { SearchNoteParams, SystemData } from 'src/app/models';
import * as moment from 'moment';
import { StorageService } from 'src/app/services/storage.service';
import { CommonWarnorconfirmPopupComponent } from '../common-warnorconfirm-popup/common-warnorconfirm-popup.component';
import { PrintService } from 'src/app/services/print.service';
import { RxTransferEnums } from 'src/app/models/rx.enum';
import { RxStore } from 'src/app/store/rx.store';
import { TranferableInformationRxsComponent } from '../tranferable-information-rxs/tranferable-information-rxs.component';
@Component({
  selector: 'app-transfer-in',
  templateUrl: './transfer-in.component.html',
  styleUrls: ['./transfer-in.component.scss']
})
export class TransferInComponent implements OnInit, OnDestroy {
  eRxModelFG: FormGroup;
  @ViewChild("NonandTransferrableRxs", { static: true })
   NonandTransferrableRxs: any;
   isFullscreenMode: boolean = false;
  @Output() ClosePopUpModal = new EventEmitter();
  @ViewChild("RejectRequest", { static: true })
  RejectRequest: any;
  @ViewChild("FAXUPDATE", { static: true })
  FAXUPDATE: any;
  
  @ViewChild("TransferRx", { static: true })
  TransferRx: any;
  @ViewChild('transferableInformation') transferableInformationComponent: TranferableInformationRxsComponent;

  modelRef: any;
  fullScreenModelRef: any;
  rxsList: any;
  cancelModelRef: any;
  faxModelRef: any;
  msgConfig = MsgConfig;
  selectedPatientDetails: any;
  selectedTransferTypeDetails: any;
  selectedDruginformation: any;
  awaitInfo: any;
  unsubscribe$: Subject<void> = new Subject();
  selectedRxList: any = [];
  IsTransferTypes: string = ''
  @Input() IsfrmPatHis;
  @Input() currentDetails;
  @Input() SelectedRecords: any;
  @Input() IsFromProcess: any;
  @Input() IsFromPatientHistory: boolean;
  @Input() IsTitle: boolean = false;
  selectedReason: any;
  expand: boolean = false;
  systemData: SystemData;
  transferRxList: any = [];
  IsClosedFullScreen:boolean = false;
  fromeRxpage: boolean;
  transferPharmacyNamefromChat: any;
  IsClearPatient: boolean = false;
  IsPharmacyFocus: boolean = false;
  listViewforPush: any = [];
  sourcePharmacyDetails: any;
  @Input()
  set DefaultTransferType(type : any){
    if(type)
    {
      this.selectedTransferTypeDetails = "All";
      this.eRxModelFG.controls['IsTransferIn'].patchValue(true);
      this.eRxModelFG.controls['transferType'].patchValue("3");
    }
  }
 @Input()
  set TransferRxsLists(list : any){
    if(list.length)
    {
      this.transferRxsList(list, true)
    }
  }
  
  @Input()
  set PatientDetails(patient : any){
     this.selectedPatientDetails = patient;
  }
 @Input()
  set IsTransferType(type : any){
     this.IsTransferTypes = type;
  }
  @Input() set IsFromErx(val) {
    if(val === 'fromeRxpage') {
      this.fromeRxpage = true;
    }
  }

  @Input()
  set AwaitInfo(awaitInf: any) {
    if (awaitInf) {
      this.awaitInfo = awaitInf;
      if (awaitInf?.Drug)
      {
        this.selectedDruginformation = awaitInf?.Drug?.result[0];
        this.eRxModelFG.controls['drugID'].patchValue(awaitInf?.Drug?.result[0]?.id);
        this.eRxModelFG.controls['IsTransferIn'].patchValue(false);
        this.eRxModelFG.controls['transferType'].patchValue("2");
      }
      else
       {
        this.selectedTransferTypeDetails = "All";
        this.eRxModelFG.controls['IsTransferIn'].patchValue(true);
        this.eRxModelFG.controls['transferType'].patchValue("3");
       }
    }
  }
  IsfromPush: boolean = false;
  IsMUltiMatchPatient: number = 0;
  IsClosedTransferInPopup: boolean = false;
  @Input()
  set DrugInformationFrmExtHist(drugInfo : any){
    if(drugInfo){
      // TransType 2 for Drug && 3 for All
      this.selectedDruginformation = drugInfo;
      this.getRxDrugDetailsById(drugInfo?.id);
      this.eRxModelFG.controls['drugID'].patchValue(drugInfo?.id);
      this.eRxModelFG.controls['IsTransferIn'].patchValue(false);
      this.eRxModelFG.controls['transferType'].patchValue("2");
    }
  }

  @Input()
  set SourcePharmacyDetails(sd: any){
    if(sd){
      this.sourcePharmacyDetails = sd;
    }
  }
  get RxTransferConfirm(): FormGroup {
    return this.eRxModelFG.get("rxTransferConfirm") as FormGroup;
}
get RxTranferNode(): FormGroup {
  return this.eRxModelFG.get("RxTranferNode") as FormGroup;
}

get TargetPharmacy(): FormGroup {
  return this.eRxModelFG.get("targetPharmacy") as FormGroup;
}

@Output() NeweRxTransferProcess = new EventEmitter();
_rxStore = inject(RxStore);

  constructor(private _fb:FormBuilder, 
              private _cdr: ChangeDetectorRef,
              private _eRxService:ErxService,
              private _alrtSev: AlertService,
              private _patUtils: PatientInfoUtil,
              private _userService: UserService,
              private _ppdiModalSer: PatPreDrugModalService,
              private _commonUtil: CommonUtil,
              private _commonServ:CommonService,
              private _modalService:NgbModal,
              public _storageService: StorageService,
              private _notesLogSvc: NotesLogService,
              private _rxSer: RxTransferService,
              private _printServ: PrintService,
               private _drugServ: DrugService) {
    this.eRxModelFG = this._fb.group({
      patientID: new FormControl(null, [Validators.required]),
      patientInfo: null,
      destinationPharmacyID: new FormControl(null, [Validators.required]),
          eRxOpID:0,
          RefillorRx: this._commonServ.getSetttingValue("PharmacySettings", "ALLOW_REFILL_TRANS_OUT") === "1" ? true : false,
          targetPharmacy: this._fb.group({
            NCPDPID: this.fromeRxpage ? new FormControl(null, [Validators.required]) : null,
            Remarks: null,
            Npi: null,
            BusinessName: new FormControl(null, [Validators.required]),
            Specialty: null,
            Address: this._fb.group(new PharmacyAddress()),
            PhoneNumbers: [],
            fax: null,
            ServiceLevel: null,
            PharmId: null
          }),
          Notes:  this._fb.group(new Notes()),
          MessageType:  null,
          rxTransferConfirm:this._fb.group(new RxTransferConfirm()),
          RxTranferNode:this._fb.group(new RxTranferNode()),
          rxFill : null,
          MessageID: null,
          RelatesToMessageID:  null,
          eRxPrescParams: [],
          prescriptionList: [],
          token:  null,
          drugID:   null,
          IsTransferIn:  false,
          IsServiceAvailablity: false,
          transferType: null,
          drugItem:   null,
          isPush:  false,
          IsManualTransferOut: false,
          rphFirstName: null,
          rphLastName: null
    });
    this._commonServ.systemData$
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe(resp => {
        if (resp) {
            this.systemData = resp;
        }
    });

   }

  ngOnInit() {
    this.eRxModelFG.controls['destinationPharmacyID'].patchValue(
      this._userService.getToken("UniquePharmacyId")
    )
    this.eRxModelFG.controls['IsServiceAvailablity'].patchValue(
      sessionStorage.getItem("ServiceAvailablity") ? (JSON.parse(this._commonServ.DecryptData(sessionStorage.getItem("ServiceAvailablity"))) ? true: false) :  false
    )
    const microSvcUrlToken = this._commonUtil.getCommonMicroSvcToken();
    this.eRxModelFG.controls['token'].patchValue(
      microSvcUrlToken
    )
     if(this.SelectedRecords?.length && this.IsTransferTypes == "XFROUT") {
      if(!this.SelectedRecords[0]["PatientId"]) {  // if no patient Id remove patientID validators 
          this.eRxModelFG.controls['patientID']?.clearValidators();
          this.eRxModelFG.controls['patientID']?.updateValueAndValidity();
      }
    this.eRxModelFG.controls['transferType'].patchValue("2");
    const isSamePatients = this.SelectedRecords.every(patient => ((patient?.PFName === this.SelectedRecords[0]?.PFName)  && (patient?.pDob === this.SelectedRecords[0]?.pDob) && (patient?.PLName === this.SelectedRecords[0]?.PLName)));
    if (this.SelectedRecords?.length  && !isSamePatients) {
      // selecting multiple records with different patients
      this.ClosePopUpModal.emit([]);
      this._alrtSev.error("Transfer requests can only be initiated for records belonging to the same patient. Please ensure all selected records belong to the same patient to proceed.");
      return;
    } else if(!this.IsTransferTypes || this.IsTransferTypes != "XFROUT") {
      //for open pop up
        this.openPopup();
        // If patient is not found and selected record count as one
         if(this.SelectedRecords?.length) {
            if (!this.SelectedRecords[0]["PatientId"]) {
              this.addNewPatient();
          }  else
          {
            this.getRxPatientDetailsById(this.SelectedRecords[0].PatientId);
            if(this.SelectedRecords[0].DrugId)
              this.getRxDrugDetailsById(this.SelectedRecords[0].DrugId);
            else {
              this.selectedDruginformation = {
                drugname: this.SelectedRecords[0]["Drug Name"],
                drugclass: this.SelectedRecords[0].DrugClass,
                ndc: this.SelectedRecords[0].DrugNDC,
                DrugDescription: this.SelectedRecords[0]["Drug Name"]
              }
              this.eRxModelFG.controls['eRxPrescParams'].patchValue([
              {
                rxTransferInOutParam: null,
                Drug : {
                  DRUGDETAIL: [{
                    DRUGNAME: this.SelectedRecords[0]["Drug Name"],
                    DRUGNDC: this.SelectedRecords[0]["DrugNDC"],
                    DRUGDESCRIPTION: this.SelectedRecords[0]["Drug Name"]
                  }]
                }
              }
              ])
            }
            this.SelectedRecords.shift();
          }
        
        }
    } else {
       this.getRxPatientDetailsById(this.SelectedRecords[0].PatientId);
       this.currentDetails = this.SelectedRecords[0];
       const pName  = this.currentDetails['totalItem']['PatientName'].split(", ");
       const patientToolTip = this.currentDetails['totalItem']["PatientToolTip"].split("\u200B");
       this.selectedPatientDetails = {
        lastname : pName?.length ? pName[0] : null,
        firstname : pName?.length ? pName[1] : null,
        telephone : this.currentDetails['totalItem']['PatientPhone'],
        fullname: this.currentDetails['totalItem']['PatientName'],
        dob: moment(this.currentDetails['totalItem']['PatientDOB']).format(MsgConfig.DATE_FORMAT),
        actstatus: 1,
        gender: patientToolTip[1],
        fulladdress: patientToolTip[2],
       }
       const  IsCompoundList = this.SelectedRecords?.filter((item: any) => { return !item?.DrugNDC && item["Drug Name"]?.trim() });
       if(IsCompoundList?.length) {            
              let modelRef: any = this._modalService.open(CommonWarnorconfirmPopupComponent, {
                  backdrop: false,
                  keyboard: false, windowClass: "max-modal-3575 large--content"
              });
                modelRef.componentInstance.IsHeaderText = (IsCompoundList?.length === this.SelectedRecords?.length) ? MsgConfig.Warn_Text_Header : MsgConfig.Delete_Header_Text;
                modelRef.componentInstance.warnMsg = (IsCompoundList?.length === this.SelectedRecords?.length) ? ("The selected eRx(s) contain compound drugs and cannot be transferred. Please process the eRx and send via fax.") : "The selected eRx(s) include compound drugs, which cannot be transferred. The eligible eRx(s) will be transferred. Do you want to proceed?";
                if (IsCompoundList?.length !== this.SelectedRecords?.length) {
                    modelRef.componentInstance.yesButton = true;
                    modelRef.componentInstance.noButton = true;
                } else {
                    modelRef.componentInstance.okButton = true;
                }
                modelRef.componentInstance.IsPopUpClosed.pipe(takeUntil(this.unsubscribe$)).subscribe((resp: any) => {
                    if(modelRef)
                    {
                        modelRef.close();
                        modelRef = null
                    }
                    if(resp) {
                      this.SelectedRecords = this.SelectedRecords?.filter((item: any) => { return item?.DrugNDC });
                      if(this.SelectedRecords?.length) {
                        this.openPopup();
                      } else {
                         this.ClosePopUpModal.emit([]);
                      }
                    } else {
                            this.ClosePopUpModal.emit([]);
                    }
                  });
       } else {
            this.openPopup();
       }
    }
   } else {
     // open pop up if no records selected
      this.openPopup();
   }

      if(((this.IsFromProcess && this.currentDetails && this.currentDetails?.PatientCount) || (this.awaitInfo && !this.IsFromProcess)) && document.getElementById("CloseTransfer")) {
        document.getElementById("CloseTransfer")?.focus();
      }
      this._rxStore.storeErxDataInfo(this.currentDetails);      
  }

     printReports(printRecords: any[]) {
       this._rxSer.printMultipleReport(printRecords).pipe(
            take(1),
            catchError((error) => {
                console.error('Error occurred while printing reports:', error);
                return of([]);
            })
        ).subscribe((resp: any) => {
            this.printReport(resp);
        });
        
    }
    printReport(resp: string[]): void {
        resp.forEach((base64data: string) => {
            this._printServ.printPdf(base64data);
          });
    }

    hasRequiredValidator() {
       return (
        (!this.eRxModelFG.value?.rphFirstName && !this.eRxModelFG.value?.rphLastName) ||
        (this.eRxModelFG.value?.rphFirstName && this.eRxModelFG.value?.rphLastName)
      );
  }
  
   ngOnChanges() {
       //For Push 
     this.eRxModelFG.controls['isPush'].patchValue(this.IsTransferTypes ? true: false)
      if(this.IsTransferType)
          this.eRxModelFG.controls['transferType'].patchValue("1");
   }
   setTransferType(drug) {
      if (drug && drug != 'All')
      {
        this.selectedDruginformation = drug;
        this.eRxModelFG.controls['drugID'].patchValue(drug?.id);
        this.eRxModelFG.controls['IsTransferIn'].patchValue(false);
        this.eRxModelFG.controls['transferType'].patchValue("2");
      }
      else
       {
        this.selectedTransferTypeDetails = "All";
        this.eRxModelFG.controls['IsTransferIn'].patchValue(true);
        this.eRxModelFG.controls['transferType'].patchValue("3");
       }
   }
  openPopup() {
    this.modelRef = this._modalService.open(this.TransferRx, {centered: true,
      backdrop: false, keyboard: false ,windowClass: "max-modal-lg-size transfer-in"});
  }

  addNewPatient() {
    this._ppdiModalSer._patPreDrugModal$.next("patient");
    const modalRef = this._ppdiModalSer.modalInstanceRef;
    const patFG:FormGroup = this._patUtils.generatePatientInfoFG();
   this._patUtils.patchPatientFrmErx(this.SelectedRecords[0].totalItem, patFG);
    modalRef.componentInstance.addPatientModel = patFG;
    modalRef.componentInstance.FrmErx = true;
    modalRef.componentInstance.erxData =  this.SelectedRecords[0].totalItem;
    modalRef.componentInstance.ClosePatientModal
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe(async resp => {
        modalRef.close();
        if(resp.PatientId)
        {
          this.getRxPatientDetailsById(resp.PatientId);
          this.getRxDrugDetailsById(this.SelectedRecords[0].DrugId);
          this.SelectedRecords.shift();
        }
        this.SelectedRecords.shift();
        this._ppdiModalSer._patPreDrugModal$.next(null);
    });
  }

  getRxDrugDetailsById(drugId) {
    this._commonServ.getRxDrugDetailsById(drugId)
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe((resp) => {
        if(resp)
          this.selectedDrugDetails(resp);
    });
  }
  
  async getRxPatientDetailsById(PatientId) {
    const patientData = await this._commonServ.getRxPatientDetailsById(PatientId).toPromise();
    if(patientData) 
    {
      this.selectedPatientDetails = patientData;
    }
  }

  selectedDrugDetails(drug: any) {
    this.selectedDruginformation = drug ? drug: null;
      if(drug) {
        this.eRxModelFG.controls['drugItem'].patchValue(drug);
        this.eRxModelFG.controls['eRxPrescParams'].patchValue([
          {
            rxTransferInOutParam: null,
            Drug : {
              DRUGDETAIL: [{
                DRUGNAME: drug.drugname,
                DRUGNDC: drug.drugcode,
                DRUGDESCRIPTION: drug.drugname,
                DrugClass: drug.drugclass
              }]
            }
          }
        ])
      }
       this.eRxModelFG.controls['transferType'].patchValue(( drug && drug !=='All') ? "2" : "3");
  }

  async closePopup() {
    if(this.IsFromProcess && this.currentDetails) {
      await this._eRxService.updateErxProcessStatus(this.currentDetails?.ErxOperationId, false).toPromise();
    }
    if(this.modelRef) {
      this.modelRef.close();
      this.modelRef = null;
    }
    this.IsClosedTransferInPopup = true;
    this.eRxModelFG.value['Notes'].IsfromTransferIn = true;
     const noteData = {
                    AnnotationNotes: [],
                    PrescrefillId: null,
                    NoteCat: null,
                    Note: [this.eRxModelFG.value['Notes']]
                }
      if(!(this.eRxModelFG.value['Notes']?.Id) && this.awaitInfo?.Note) {
        this.eRxModelFG.controls['Notes'].patchValue(this.awaitInfo?.Note);
      }
      if(this.awaitInfo && this.eRxModelFG.value['Notes'] && this.eRxModelFG.value['Notes'].Id) {
                this._notesLogSvc.updateNotesLog(noteData)
                          .pipe(takeUntil(this.unsubscribe$))
                          .subscribe(resp => {
                          });
      } else if(this.eRxModelFG.value['Notes'] && this.eRxModelFG.value['Notes'].xNote && this.currentDetails) {
        this._notesLogSvc
            .addNotesLog("Rx", this.currentDetails['ID'], noteData)
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(resp => {
            });
      }
    this.awaitInfo = null;
    this._storageService.removedSessionStorage("fromDrugGrid");
      this.ClosePopUpModal.emit('');
  }

  selectedTransTypeDetails(details: any) {
      this._cdr.detectChanges();
      this.selectedTransferTypeDetails = details;
      if(details && details !== "All")
      {
        this.eRxModelFG.controls['drugID'].patchValue(details);
        this.eRxModelFG.controls['IsTransferIn'].patchValue(false);
      }
      else if(details == "All")
      {
        this.eRxModelFG.controls['IsTransferIn'].patchValue(true);
      }
  }

  selectedPatientID(patient) {
      this.eRxModelFG.controls['patientID'].patchValue(patient ? patient?.patientid : null);
      this.eRxModelFG.controls['patientInfo'].patchValue(patient ? patient : null);
      this.IsClearPatient = patient ?  false : true;
      this.IsPharmacyFocus = (patient && !patient?.isdeceased) ?  true : false;
  }

  transferSingleNotes(event) {
        event["PopupScreenCodes"] = event["PopupScreenCodes"]?.length ? event["PopupScreenCodes"]?.toString() : null;
        event["IsfromTransferIn"]   = true;
        event["IsShownAsPopup"]  = event["PopupScreenCodes"]?.length ? true : false;
        event["Name"]  = event["Name"]?.length ? event["Name"].trim() : null;
        this.eRxModelFG.controls['Notes'].patchValue(event);
  }

  closeDenieModal() {
      if(this.cancelModelRef) {
        this.cancelModelRef.close();
        this.cancelModelRef = null;
      }
      this.eRxModelFG.controls['RxTranferNode'].patchValue({
        ResponseReasonCode: null,
        ResponseValue: null
      });
    }

  async rxTransfer(type) {
    const loggedPharmaFax = this._commonServ.getSetttingValue("FaxAndReportsSettings", "Fax_Number");
    this.RxTranferNode.controls['ResponseValue'].patchValue(type === 'TransferOut' ? "Approved" : type);
    this.eRxModelFG.controls['eRxOpID'].patchValue(this.currentDetails?.ErxOperationId);
    //await this.addNotesToRequest(this.eRxModelFG.value['Notes']);
    if (type === 'InReq') {
      if(this.eRxModelFG?.value?.transferType == 3) {  // Transfer Type 3 for All
         this.eRxModelFG.controls["eRxPrescParams"].patchValue(null);
      }
      if (this.eRxModelFG.valid && (this.eRxModelFG.value['drugID'] || this.eRxModelFG.value['IsTransferIn'])) {
        this._eRxService.sendTransferInReq(this.eRxModelFG.value, this._commonUtil.getErxVersion()).subscribe((resp: any) => {
          if (resp?.Result) {
            this._alrtSev.success(MsgConfig.Transfer_In_Req);
          } else if (resp?.Message && !resp?.Result) {
            this._alrtSev.error(resp.Message);
          }
          this.closePopup();
        });
      }
    } else if (type === 'Denied') {
      this.cancelModelRef = this._modalService.open(this.RejectRequest, { keyboard: false, centered: true, backdrop: false });
    } else if (type === 'TransferOut') {
       this.eRxModelFG.controls['IsManualTransferOut'].patchValue(!loggedPharmaFax && !this.eRxModelFG.value['IsServiceAvailablity']);
       if (this.rxsList?.find((item: any) => { return item.IsElectronic === 1 }) && !loggedPharmaFax) {
        const modalRef: any = this._modalService.open(CommonWarnorconfirmPopupComponent, { centered: true, backdrop: false, keyboard: false,
          windowClass: "large--content" });
          modalRef.componentInstance.warnMsg = "The following Rx(s) cannot be faxed because the pharmacy does not have a fax number:" + 
          "<br> <span> Rx#: <b>" +  this.rxsList?.filter((item: any) => { return item.IsElectronic === 1 }).map((item: any) => { return item.Prescription.PrescNum }).join(", ") + "</b><br><br>Would you like to mark them as <b>Transferred Out?";
          modalRef.componentInstance.yesButton = true;
          modalRef.componentInstance.noButton = true;
          modalRef.componentInstance.IsHeaderText = MsgConfig.Delete_Header_Text;
          modalRef.componentInstance.IsPopUpClosed.pipe(takeUntil(this.unsubscribe$)).subscribe((resp: any) => {
            if (modalRef) {
              modalRef.close();
            }
            if(resp)
                this.sendResponseToDestination("TransferOut");
          });
      } else if(loggedPharmaFax && this.rxsList?.length && this.rxsList.some((item: any) => { return item.IsElectronic === 1})) {
           let faxNum;
           const phoneNumbers = this.TargetPharmacy.value["PhoneNumbers"];
            if(phoneNumbers?.length) { // to pacth the fax number if it is already present in the eRxModelFG
              faxNum = phoneNumbers?.find((item: any) => item?.Type === 'Fax');
               this.TargetPharmacy.controls.fax.patchValue(faxNum && faxNum?.Number ? faxNum?.Number : null); 
            }
            if(!faxNum?.Number)
               this.faxModelRef = this._modalService.open(this.FAXUPDATE, { keyboard: false, centered: true });
            else 
               this.sendResponseToDestination(["TransferOutWithRxs", "XFROUT",'TransferOutWithFax'].includes(this.IsTransferTypes) ? 'TransferOut' : null);
          } else if(this.rxsList?.length) {
                this.sendResponseToDestination('TransferOut');
          } else {
            this._alrtSev.error(MsgConfig.Unselect_Warn);
          }
    }  else {
      const phoneNumbers = this.TargetPharmacy.value["PhoneNumbers"];
      let faxNum;
      if(this.awaitInfo.PrescriptionData?.PrescriptionData?.PharmacyDetail?.SourcePharmacy?.PhoneNumbers?.length) {
        faxNum = this.awaitInfo.PrescriptionData?.PrescriptionData?.PharmacyDetail?.SourcePharmacy?.PhoneNumbers?.find((item: any) => item?.Type === 'Fax');
      }
      if (this.rxsList?.find((item: any) =>  {return item.IsElectronic === 1}) && !loggedPharmaFax) {
        const modalRef: any = this._modalService.open(CommonWarnorconfirmPopupComponent, { centered: true, backdrop: false, keyboard: false,
          windowClass: "large--content" });
          modalRef.componentInstance.warnMsg = "The selected prescriptions marked for fax transfer out will not be sent via fax, as the pharmacy has no fax number. Please update the fax number to proceed.";
          modalRef.componentInstance.yesButton = true;
          modalRef.componentInstance.IsHeaderText = MsgConfig.Warn_Text_Header;
          modalRef.componentInstance.IsPopUpClosed.pipe(takeUntil(this.unsubscribe$)).subscribe((resp: any) => {
            if (modalRef) {
              modalRef.close();
            }
             if(!this.eRxModelFG.value['isPush'])
                this.rxsList = this.rxsList.filter((item: any) => {return item.IsElectronic != 1} );
            this.eRxModelFG.controls['IsManualTransferOut'].patchValue(this.eRxModelFG.value['isPush']);
            this.sendResponseToDestination();
          });
      }
      else if(this.rxsList?.length && this.rxsList.filter((item: any) => {return item.IsElectronic === RxTransferEnums.Fax} ) && phoneNumbers?.find((item: any) => item.Type === 'Fax'))
          this.sendResponseToDestination();
      else {
        if(this.rxsList?.length && this.rxsList.some((item: any) => { return item.IsElectronic ===  1 })) {
           if(!faxNum?.Number)
             this.faxModelRef = this._modalService.open(this.FAXUPDATE, { keyboard: false, centered: true });
           else 
            {
              this.TargetPharmacy.controls.fax.patchValue(faxNum && faxNum?.Number ? faxNum?.Number : null);
              this.sendResponseToDestination();
            }
             this.TargetPharmacy.controls.fax.patchValue(faxNum && faxNum?.Number ? faxNum?.Number : null); 
          } else if(this.rxsList?.length) {
            this.sendResponseToDestination();
          } else {
            this._alrtSev.error(MsgConfig.Unselect_Warn);
          }
      }
    }
  }

  closeFax() {
     if(this.faxModelRef) {
      this.faxModelRef.close();
      this.faxModelRef = null;
    }
  }
  
  updateFax() {
    if(this.faxModelRef) {
      this.faxModelRef.close();
      this.faxModelRef = null;
    }
    if(this.TargetPharmacy?.value?.fax)
    {
      const updateFax = {Type : 'Fax' , Number: this.TargetPharmacy?.value?.fax};
      if(this.TargetPharmacy?.value['PhoneNumbers']?.length) {
        const existingFax = this.TargetPharmacy?.value['PhoneNumbers'].find((item: any) => item.Type === 'Fax');
        if(existingFax) {
          existingFax.Number = this.TargetPharmacy?.value?.fax;
        } else {
          this.TargetPharmacy.value['PhoneNumbers'].push(updateFax);
        }
    } else {
      if(!this.TargetPharmacy?.value['PhoneNumbers'] || !this.TargetPharmacy?.value['PhoneNumbers']?.length)
        this.TargetPharmacy.value['PhoneNumbers'] = [];
        this.TargetPharmacy.value['PhoneNumbers'].push(updateFax);
    }
  }
      this.sendResponseToDestination(this.IsTransferTypes === 'XFROUT' ? 'TransferOut' : null);
  }
  async sendResponseToDestination(isType?) {
    if(isType ||  this.rxsList?.length)
    {
      await this.patchTheSeletcedRxs();
      const payload =  Object.assign({}, this.eRxModelFG.value);
      if(!payload?.TargetPharmacy?.Npi) {
        payload['XferPharmIdxId'] = payload?.targetPharmacy?.PharmId;
      }
      delete payload?.targetPharmacy?.PharmId;
      this._eRxService.setRxsForTransferInReqProcess(payload).subscribe((resp: any) => {
        if(resp && resp?.Result) {
           this.closePopup();
          // Printing the fax records
              if(resp?.Response ===2) {
                     this._alrtSev.warning("Rx Transfer Out sent successfully. However, the following Rx(s): " +  (resp?.Message)  + " have already been transferred by another user.");
                }
                else
                  this._alrtSev.success((isType === 'TransferOut') ? MsgConfig.Transfer_Out_Message : MsgConfig.Transfer_In_Req_Process);  
          const faxRecords =  this.rxsList?.filter((item: any) => item.IsElectronic === RxTransferEnums.Fax);
          if(faxRecords?.length) {
            const printRecords  =  faxRecords.map((item: any) => {
              const prescReFill = resp?.prescRefills.find((ele: any) => item.Prescription.PrescNum === ele.PrescNum);
            return  {
                transferType: "TransferOut",
              FromPrescRefillId:  prescReFill ? prescReFill.PrescRefillId : 0,
              RxNum: item.Prescription.PrescNum ? item.Prescription.PrescNum : item.Prescription.RxNum, 
              IsRxNotTransferredIn: false
              }
              });
              this.printReports(printRecords);
            }        
        } else if(resp?.Response ===2) {
             this.closePopup();
           this._alrtSev.error("Rx transfer for the selected Rx(s): " + (resp?.Message) + " has been transferred by a different user.");
        } else if (resp?.Response === 3 && !resp.Result) {
          this.closePopup();
          this._alrtSev.error("The transfer-in request you're trying to process has already processed in another station.");
        }
      });
    } else {
      this._alrtSev.error(MsgConfig.Unselect_Warn);
    }
  }
  addNotesToRequest(pharmacistNotes) {
    if(pharmacistNotes.xNote && (!pharmacistNotes.NoteCatId && pharmacistNotes.Name)) {
    const notesCatList: any = this._commonServ.notesCatList$["source"]["value"];
    const mainCat = notesCatList.find((val: any) =>  (val.CategoryName.toUpperCase() === NotesMainCat.eRx.toUpperCase()) );
    this._drugServ.addoRUpdateNoteCategory(
      {
        Name: pharmacistNotes.Name,
        NoteCategoryId: mainCat?.CategoryId,
        IsActive: true,
        CreatedDtTm: null,
        Id: 0
      },
      "SAVE"
    ).subscribe((resp: number) => {
      if (resp) {
        this.getNotesSubacatList({
          Name: pharmacistNotes.Name,
          pharmacistNotes:pharmacistNotes
        });
      }
    });
  }
  }
  getNotesSubacatList(catObj?: any) {
    this._notesLogSvc
    .getNotesLog(
      NotesMainCat.Rx,0,
      MsgConfig.Default_Date_Notes,
      moment(Date.now()).format(MsgConfig.DATE_FORMAT_WITH_EIPHEN),
        new SearchNoteParams()
    )
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe((resp: any) => {
        if(resp)
        {
            if(catObj?.Name) {
              let manualSubCat = resp?.NoteCat?.find((item: any) => (catObj.Name.toUpperCase() === item?.Name?.toUpperCase()));
              if(catObj?.pharmacistNotes)
              {
                  catObj.pharmacistNotes.NoteCatId  =  manualSubCat ? manualSubCat.Id : 0, 
                   this.eRxModelFG.controls['Notes'].patchValue(catObj.pharmacistNotes);
              }
            }
        }
    });
  }
  selectedToPharmacy(selectedPharmacy) {
      let phones: any = [];
      if(selectedPharmacy) {
        selectedPharmacy.ServiceLevels = selectedPharmacy?.ServiceLevels ? selectedPharmacy?.ServiceLevels : false;
      }
      if(selectedPharmacy?.Phone) 
        phones.push({Type : 'Phone' , Number: selectedPharmacy.Phone});
      if(selectedPharmacy?.Fax) 
        phones.push({Type : 'Fax' , Number: selectedPharmacy.Fax});
      const pharmacy = {
        NCPDPID : selectedPharmacy?.NCPDPID ? selectedPharmacy?.NCPDPID : null,
        Npi : selectedPharmacy?.NPINum ? selectedPharmacy?.NPINum :  null,
        BusinessName: (selectedPharmacy?.PharmName) ? selectedPharmacy?.PharmName : null,
        PhoneNumbers: phones.length ? phones : [],
        Specialty : null,
        Remarks: selectedPharmacy?.Remarks,
        PharmId: selectedPharmacy?.PharmId ? selectedPharmacy?.PharmId : null,
        Address : {
          AddressLine1: (selectedPharmacy?.AddressLine1) ? selectedPharmacy.AddressLine1 : null,
          AddressLine2: selectedPharmacy?.AddressLine2 ? selectedPharmacy.AddressLine2 : null,
          City: (selectedPharmacy) ? selectedPharmacy.CityName : null,
          State:  (selectedPharmacy) ? selectedPharmacy.StateName : null,
          ZipCode: (selectedPharmacy) ? selectedPharmacy.ZipCode : null,
          CountryCode: (selectedPharmacy) ? selectedPharmacy.CountryCode : null
        },
        ServiceLevel: selectedPharmacy?.ServiceLevels
      }
      this.eRxModelFG.controls['targetPharmacy'].patchValue(pharmacy)
      const transferInReq = document.getElementById(this.IsTransferTypes !== "XFROUT" ? "rxTransferInReq" : "transferOut");
       if(transferInReq && selectedPharmacy?.ServiceLevels)
        transferInReq.focus();
      if(selectedPharmacy && this.transferableInformationComponent?.reloadGridDataOnPharmacyChange) {
        this.transferableInformationComponent.reloadGridDataOnPharmacyChange();
      }
      
  }
  cancelRxReasonSelected(selectedRea, IsFrmNotes: boolean = false) {
    if(IsFrmNotes && selectedRea) {
         this.RxTranferNode.patchValue({
        ResponseReason: selectedRea
      });
    } else if (selectedRea) {
      this.RxTranferNode.patchValue({
        ResponseReasonCode: selectedRea?.Code,
        ResponseReason: selectedRea?.Description
      });
    }else {
      this.RxTranferNode.patchValue({
        ResponseReasonCode: null,
        ResponseReason: null
      });
    }
   
  }
  patchTheSeletcedRxs() {
   const  RefillorRx =  this._commonServ.getSetttingValue("PharmacySettings", "ALLOW_REFILL_TRANS_OUT") === "1" ? true : false
    const eRxPrescParam: any  = [];
    if(this.rxsList?.length) {
      this.rxsList.map((item: any) => {
      eRxPrescParam.push({
        RxId: item.Prescription.PrescNum,
        IsTransfferable: item?.IsElectronic == 3 ? false : item?.IsTransfferable,
         prescRefillId: item?.PrescReFill.Id,
         isCurrentRefillTransfer: RefillorRx ? false : !!item?.isCurrentRefillTransfer,
        IsElectronic:  !item?.IsTransfferable ? true : ((item?.IsElectronic === 1 || item?.IsElectronic === false) ? false : true)
      });
    });
    this.eRxModelFG.controls["eRxPrescParams"].patchValue(eRxPrescParam);
}
  }
  acceptOrRejectRequest(isType: string) {
    if(!this.RxTranferNode?.value?.ResponseReason || !this.RxTranferNode?.value?.ResponseReasonCode) {
          this._alrtSev.error(MsgConfig.Select_Reason_Transfer);
    } else {
            if(this.cancelModelRef) {
              this.cancelModelRef.close();
              this.cancelModelRef = null;
            }
             this.sendResponseToDestination('Denied');
          }
  }
  getTheSelectedRxs(rxsList, IsClosedFullScreen?) {
    this.IsClosedFullScreen = IsClosedFullScreen;
      this.rxsList = rxsList;
      if(this.rxsList?.length) {
        let erxItem = rxsList.find((item: any) => { return item.isNotProcessedErx === true; });
        if(erxItem && erxItem?.eRxListingViewModel) {
            erxItem.eRxListingViewModel['ID'] = erxItem?.eRxListingViewModel?.Id;
            erxItem.eRxListingViewModel['Message Type'] = erxItem?.eRxListingViewModel?.MessageType;
            erxItem.eRxListingViewModel['Patient Name'] = erxItem?.eRxListingViewModel?.PatientName;
            erxItem.eRxListingViewModel['Drug Name'] = erxItem?.eRxListingViewModel?.DrugName;
            erxItem.eRxListingViewModel['Date & Time'] = erxItem?.eRxListingViewModel?.EROPTransactionId;
            erxItem.eRxListingViewModel['Prescriber Name'] = erxItem?.eRxListingViewModel?.FileDtTm ? moment.utc(erxItem?.eRxListingViewModel?.FileDtTm).local().format("MM/DD/YY  hh:mm:ss") : null;
            this.NeweRxTransferProcess.emit(erxItem?.eRxListingViewModel);
        }
      }
  }
  
  getPatientSelection(patient: any) {
       this.selectedPatientDetails = patient;
  }

  showFullscreenMode() {
    this.isFullscreenMode = true;
    this.IsClosedFullScreen = false;
    this.fullScreenModelRef = this._modalService.open(this.NonandTransferrableRxs, {centered: true, backdrop: false, windowClass: "max-modal-lg-size"}); 
  }

  closeRxPopup() {
        this.isFullscreenMode = false;
        if(this.fullScreenModelRef) {
          this.fullScreenModelRef.close();
          this.fullScreenModelRef = null;
        }
  }

  showDetails() {
    this.expand = !this.expand;
  }

  transferRxsList(list, IsfromHistry: boolean = false) {
     this.transferRxList = list;
     if(this.transferRxList.length && !this.eRxModelFG.value['patientInfo'] && !IsfromHistry)
     {
        this.selectedPatientID(this.transferRxList[0].Patient);
        this.selectedPatientDetails = this.transferRxList[0].Patient;
     } 
  }

  reSelectPatient(Patient) {
    this.selectedPatientID(Patient);
    this.selectedPatientDetails = Patient;
  }

  ngOnDestroy(): void {
    this._rxStore.storeErxDataInfo(null);
  }
}
